import { Component, computed, input } from '@angular/core';
import { EmptyClass, isNotNullOrUndefinedOrEmpty, LocationInfo } from 'in-time-core';
import { LocalizationMixinSignals } from '../../../core/mixins/localization-mixin-signal';

@Component({
  standalone: true,
  selector: 'app-location-info',
  templateUrl: './location-info.component.html',
})
export class LocationInfoComponent extends LocalizationMixinSignals(EmptyClass) {
  public readonly locationInfo = input.required<LocationInfo>();

  public readonly location = computed(() => {
    const locationInfo = this.locationInfo();
    let result = this.getLocalizedText(locationInfo.localizedName) ?? '';

    const city = locationInfo.city;
    if(isNotNullOrUndefinedOrEmpty(city)) {
      result = result + ', ' + city;
    }

    const address = locationInfo.address;
    if(isNotNullOrUndefinedOrEmpty(address)) {
      result = result + ', ' + address;
    }

    return result;
  });
}
